import { createContext, useContext } from 'react';

import { Component } from 'models';

export const ComponentBulkFieldsContext = createContext<{
    same: string[];
    diff: string[];
    overrides: string[];
    addOverride: (key: string) => void;
    removeOverride: (key: string) => void;
    bulkSave: (component: Component) => Promise<void>;
    isSaving: boolean;
}>({
    same: [],
    diff: [],
    overrides: [],
    addOverride: () => {},
    removeOverride: () => {},
    bulkSave: async () => {},
    isSaving: false,
});

export const useComponentBulkFields = () => useContext(ComponentBulkFieldsContext);
